import React, { useState, useEffect } from 'react';
import { Tabs, Toast } from 'antd-mobile';
import TypeSeries from '../TypeSeries'; // 导入类型系列组件
import FilesSeries from '../FilesSeries'; // 导入文件系列组件
import { fetchIndustries } from '../../services/services'; // 导入获取行业数据的服务函数
import { locale } from '../../config/config';
export default function Universal() {
  // 状态定义：当前激活的行业
  const [activeIndustry, setActiveIndustry] = useState();
  // 状态定义：行业列表
  const [industries, setIndustries] = useState([]);

  // 加载行业列表
  useEffect(() => {
    fetchIndustries().then(res => {
      if (res.status === 200) {

        // 重新排列行业列表的顺序
        const rearrangedRes = [
          res.result[2],
          res.result[3],
          res.result[1],
          res.result[5],
          res.result[4],
          res.result[0],
        ];

        localStorage.setItem("idArray",JSON.stringify(rearrangedRes.map(item => item.id)))
        setIndustries(rearrangedRes); // 设置行业列表
        setActiveIndustry(localStorage.getItem("one")); // 设置默认激活的行业
      } else {
        // 显示错误提示
        Toast.show({
          content: res.error,
          duration: 3000,
        });
      }
    });
  }, []);

  return (
    <div>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: '#fff',
        }}
      >
        {/* 使用 Tabs 组件显示行业列表，并提供行业切换功能 */}
        <Tabs
          activeKey={activeIndustry} // 当前激活的行业
          style={{
            '--active-line-color': '#3eb044', // 激活线的颜色
            '--active-title-color': '#333333', // 激活标题的颜色
            '--content-padding': '0', // 内容边距
            '--active-line-height': '1.026vw', // 激活线的高度
            '--title-font-size': '3.077vw', // 标题字体大小
          }}
          onChange={key => {
            setActiveIndustry(key); // 切换行业时更新当前激活的行业
          }}
        >
          {industries.map(item => {
            return (
              // 每个 Tab 对应一个行业，并显示相应的类型系列
              <Tabs.Tab
                title={item.name[locale]} // Tab 标题为行业中文名称
                key={item.id} // Tab 键为行业 ID
              >
                <TypeSeries activeTab={activeIndustry} /> {/* 显示对应行业的类型系列 */}
              </Tabs.Tab>
            );
          })}
        </Tabs>
      </div>
      <FilesSeries /> {/* 显示文件系列 */}
    </div>
  );
}
